import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { selectLotForEdit } from '../../../../store/actions/RU/creationLotActions';
import { loadSubLots } from '../../../../store/actions/RU/creationSubLotActions';
import { loadOptionalsStoreByLot } from '../../../../store/actions/carOptionals/carOptionalsActions';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import UsedRentalsAPI from '../../../../API/UsedRentalsAPI';
import UsedRentalsManagementAPI from '../../../../API/UsedRentalsManagementAPI';
import RUTableHeader from './RUTableHeader';
import RULotToolBar from './RULotToolBar';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '../../../Utils/LinearProgress';
import SnackbarAlert from '../../../Utils/SnackbarAlert';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_BRAND, NEGOTIATION_PHASE, UR_PHASE } from '../../../../Utils/Constants';
import { handleServerError } from '../../../../Utils/Helper';

const styles = theme => ({
  paperRoot: {
    width: '100%',
    backgroundColor: '#F6F6F6',
  },
  tableWrapper: {
    overflowX: 'auto',
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center',
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  cellPadding: {
    paddingLeft: '6px',
  },
  buttons: {
    float: 'right',
    display: 'flex',
  },
  qttyWidth: {
    width: '76px'
  },
  fDateWidth: {
    width: '192px'
  },
  editWidth: {
    width: '44px'
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


class RUCreationLotsTableList extends React.Component {
  _isMounted;
  searchTimer = null;
  tableDataAPI;
  tableDataRUAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_BRAND,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      reloading: false,
      openError: false,
      alertMessage: '',
      lotStateId: this.props.showContent === 'creationUsedRentals' ? NEGOTIATION_PHASE : this.props.showContent === 'usedRentals' ? UR_PHASE : 0
    };
    this.tableDataAPI = new UsedRentalsAPI();
    this.tableDataRUAPI = new UsedRentalsManagementAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    this.reloadTable();
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props !== prevProps) {
      if (this.props.shouldReloadList)
        this.reloadTable();
    }
  }

  reloadTable() {
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.showContent === 'usedRentals') {
      tableData = this.tableDataRUAPI.getRULots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.orderBy, this.order, this.state.lotStateId, this.searchBy);
    }
    else {
      tableData = this.tableDataAPI.getRUCreationLots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.orderBy, this.order, this.state.lotStateId, this.searchBy);
    }
    tableData.then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.LotList,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.showContent === 'usedRentals') {
      tableData = this.tableDataRUAPI.getRULots(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.lotStateId, this.state.search);
    }
    else {
      tableData = this.tableDataAPI.getRUCreationLots(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.lotStateId, this.state.search);
    }
    tableData.then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.LotList,
          count: response.data.NumberFilteredResults,
          order, orderBy,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.showContent === 'usedRentals') {
      tableData = this.tableDataRUAPI.getRULots(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.lotStateId, this.state.search);
    }
    else {
      tableData = this.tableDataAPI.getRUCreationLots(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.lotStateId, this.state.search);
    }
    tableData.then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.LotList,
          count: response.data.NumberFilteredResults,
          page: page,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    var tableData = {};
    if (this.props.showContent === 'usedRentals') {
      tableData = this.tableDataRUAPI.getRULots(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.lotStateId, this.state.search);
    }
    else {
      tableData = this.tableDataAPI.getRUCreationLots(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.lotStateId, this.state.search);
    }
    tableData.then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.LotList,
          count: response.data.NumberFilteredResults,
          rowsPerPage: event.target.value,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  reloadTableByState(nStateId) {
    this.setState({ reloading: true });
    this.tableDataAPI.getRUCreationLots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, nStateId, this.state.search).then((response) => {
      if (this._isMounted)
        this.setState({
          data: response.data.LotList,
          count: response.data.NumberFilteredResults,
          lotStateId: nStateId,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
    }).catch((error) => {
      if (this._isMounted)
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      var tableData = {};
      if (this.props.showContent === 'usedRentals') {
        tableData = this.tableDataRUAPI.getRULots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.lotStateId, searchBy);
      }
      else {
        tableData = this.tableDataAPI.getRUCreationLots(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.lotStateId, searchBy);
      }
      tableData.then((response) => {
        if (this._isMounted)
          this.setState({
            data: response.data.LotList,
            count: response.data.NumberFilteredResults,
            search: searchBy,
            page: STARTING_TABLE_PAGE,
            reloading: false
          });
      }).catch((error) => {
        if (this._isMounted)
          this.setState({
            reloading: false,
            openError: true,
            alertMessage: handleServerError(error)
          })
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  triggerEditLotMainForm(lotItem) {
    this.props.selectLotForEdit(lotItem);
    this.props.loadSubLots(lotItem.SubLotIdList);
    this.props.loadOptionalsStoreByLot(lotItem.SubLotCarOptionals);
    this.props.openEditLotMainForm(lotItem, this.state.optionalsSubLot);
  };

  triggerEditRUForm(lotItem) {
    this.props.selectLotForEdit(lotItem);
    this.props.loadOptionalsStoreByLot(lotItem.SubLotCarOptionals);
    this.props.loadSubLots(lotItem.SubLotIdList);
    this.props.openEditRULotMainForm(lotItem);
  };

  renderTableRecords(lotList) {
    const { classes } = this.props;

    return lotList.map(lotItem => {
      return (
        <TableRow key={lotItem.L1ID} tabIndex={-1} className={classes.tblRow}>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {lotItem.Brand}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {lotItem.Model}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.qttyWidth)} component='th' scope='row' padding='none'>
            {lotItem.Quantity}
          </TableCell>
          {this.state.lotStateId === UR_PHASE ?
            <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.qttyWidth)} component='th' scope='row' padding='none'>
              {lotItem.AvailableCarsQtty}
            </TableCell>
            : null
          }
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.fDateWidth)} component='th' scope='row' padding='none'>
            {lotItem.FormalizationDate}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {lotItem.LotLPPT}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {lotItem.SaleChannel.join(' || ')}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.editWidth)} padding='none'>
            <Tooltip title='Editar Lote' placement='bottom'>
              {(this.props.showContent === 'usedRentals' && this.state.lotStateId === UR_PHASE) ?
                <IconButton aria-label='Edit' onClick={() => this.triggerEditRUForm(lotItem)} className={classes.buttonSizeTbl} >
                  <EditIcon />
                </IconButton>
                :
                (this.props.showContent === 'creationUsedRentals') ?
                  <IconButton aria-label='Edit' onClick={() => this.triggerEditLotMainForm(lotItem)} className={classes.buttonSizeTbl} >
                    <EditIcon />
                  </IconButton>
                  :
                  <IconButton aria-label='Edit' onClick={() => this.triggerEditRUForm(lotItem)} className={classes.buttonSizeTbl} >
                    <EditIcon />
                  </IconButton>
              }
            </Tooltip>
          </TableCell>
        </TableRow>
      );
    });
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes, negotiationLotStateList } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading, lotStateId } = this.state;

    return (
      <Paper className={classes.paperRoot}>

        <RULotToolBar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTableByState={this.reloadTableByState.bind(this)}
          reloadTable={this.reloadTable.bind(this)}
          negotiationLotStateList={negotiationLotStateList}
          titleTableList={this.props.titleTableList}
          showContent={this.props.showContent}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <RUTableHeader
              order={order}
              orderBy={orderBy}
              onRequestSort={this.handleRequestSort}
              lotStateId={lotStateId}
            />
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUCreationLotsTableList.propTypes = {
  classes: PropTypes.object.isRequired,
  openEditLotMainForm: PropTypes.func,
  openEditRULotMainForm: PropTypes.func,
  reloadTableBySearch: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

const mapDispatchToProps = dispatch => ({
  selectLotForEdit: (negotiationItem) => dispatch(selectLotForEdit(negotiationItem)),
  loadSubLots: (aSubLotIds) => dispatch(loadSubLots(aSubLotIds)),
  loadOptionalsStoreByLot: (oLotOptionals) => dispatch(loadOptionalsStoreByLot(oLotOptionals))
});

export default connect(mapStateToProps, mapDispatchToProps, null, { forwardRef: true })(withStyles(styles)(RUCreationLotsTableList));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsCreation/UsedRentalsLots/RUCreationLotsTableList.js